import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Panel from '../../atoms/Panel';
import H3 from '../../atoms/title/H3';
import DossierDetails from '../../molecules/list/DossierDetails';
import DossierFinances from '../../molecules/list/DossierFinances';
import CloseDossierModal from '../modals/CloseDossierModal';
import ReportAmountModal from '../modals/ReportAmountModal';
import { isProject, PROJECT_INKASSIER, PROJECT_INVONED, } from '../../../services/appTheme';
import InvonedDossierFinances from '../../molecules/list/Invoned/InvonedDossierFinances';
import InvonedDossierDetails from '../../molecules/list/Invoned/InvonedDossierDetails';
import Button, { ButtonVariants } from '../../atoms/Button';
import Flex from '../../atoms/Flex';
import Payments from '../../atoms/icons/Payments';
import { useTranslation } from 'react-i18next';
import Notice, { TYPES } from '../../molecules/Notice';
import Warning from '../../atoms/icons/Warning';
import { readableNumberParts } from '../../../helpers/Numbers';
import { withInertiaPage } from '../../../hoc/withInertiaPage';
import AddressInfoModal from '../modals/AddressInfoModal';
import { useOnHashChange } from '../../hooks/useOnHashChange';
import { useToast } from '../toast/ToastContext';
import OtherDossiers from '../../molecules/list/OtherDossiers';
import { readableDate } from '../../../helpers/Date';
import DossierCourtCalendar from '../../molecules/list/DossierCourtCalendar';
const ADDR_INFO_HASH_RE = /(addressInfoModalOpen)=(true|false)/;
const StyledPayments = styled(Payments) `
    fill: #ffffff;
`;
const Sticky = styled.div `
    position: sticky;
    position: -webkit-sticky;
    top: 100px;
    z-index: 5;
`;
export const SideBar = ({ page, dossier }) => {
    const { t } = useTranslation();
    const [reportModalOpen, setReportModalOpen] = useState(false);
    const [dossierModalOpen, setDossierModalOpen] = useState(false);
    const [addressInfoModalOpen, setAddressInfoModalOpen] = useState(false);
    const { add: addToast } = useToast();
    const { hash } = useOnHashChange();
    useEffect(() => {
        (hash.match(ADDR_INFO_HASH_RE) ?? [])
            .slice(2)
            .map(open => open === 'true')
            .map(open => setAddressInfoModalOpen(open));
    }, [hash]);
    const getArrangementNotice = (arrangement) => {
        let text = '';
        if (arrangement.type === 'B') {
            text = t('dossier.seizure_notice');
        }
        else if (arrangement.type === 'R') {
            const transProps = {
                ...arrangement,
                amount: readableNumberParts(arrangement.amount, 'EUR')
                    .longDecimal,
                count: arrangement.interval_frequency,
                start_date: readableDate(arrangement.start_date),
            };
            const termOptions = {
                dagen: t('dossier.payment_arrangement_notice_day', transProps),
                week: t('dossier.payment_arrangement_notice_week', transProps),
                maand: t('dossier.payment_arrangement_notice_month', transProps),
            };
            text =
                termOptions[arrangement.interval_term] ||
                    t('dossier.payment_arrangement_notice_undefined', {
                        amount: transProps.amount,
                    });
        }
        else {
            return;
        }
        return (_jsx(Notice, { icon: _jsx(Warning, {}), title: t('dossier.payment_arrangement_notice_title'), text: text, type: TYPES.WARNING }));
    };
    return (_jsxs(Sticky, { "data-testid": "sidebar", children: [_jsxs(Flex, { column: true, margin: "0 0 5px 0", children: [(page.props.domain?.dossier_report_payment ||
                        page.props.domain?.can_close_dossier) &&
                        !dossier.closed_at && (_jsx(_Fragment, { children: page.props.domain?.dossier_report_payment && (_jsx(Button, { tertiary: true, fullWidth: true, icon: _jsx(StyledPayments, {}), margin: "0 0 10px 0", onClick: () => setReportModalOpen(true), children: t('report_payment.submit') })) })), isProject(PROJECT_INVONED) && (_jsx(Button, { variant: ButtonVariants.Gray, fullWidth: true, margin: "0 0 10px 0", onClick: () => setAddressInfoModalOpen(true), children: t('address_info.title') })), (page.props.domain?.dossier_report_payment ||
                        page.props.domain?.can_close_dossier) &&
                        !dossier.closed_at && (_jsx(_Fragment, { children: page.props.domain?.can_close_dossier && (_jsx(Button, { variant: ButtonVariants.Gray, fullWidth: true, margin: "0 0 10px 0", onClick: () => setDossierModalOpen(true), children: t('close_dossier.title') })) }))] }), _jsxs(Panel, { hasNarrowPanelHeight: true, children: [_jsx(H3, { children: t('sidebar.title.details') }), isProject(PROJECT_INKASSIER) &&
                        'closing_reason' in dossier && (_jsx(DossierDetails, { dossier: dossier })), isProject(PROJECT_INVONED) &&
                        'closing_description' in dossier && (_jsx(InvonedDossierDetails, { dossier: dossier })), 'latest_payment_arrangement' in dossier &&
                        dossier.latest_payment_arrangement &&
                        getArrangementNotice(dossier.latest_payment_arrangement), 'latest_seizure' in dossier &&
                        dossier.latest_seizure &&
                        getArrangementNotice(dossier.latest_seizure), isProject(PROJECT_INKASSIER) &&
                        ('other_open_dossiers_count' in dossier ||
                            'other_closed_dossiers_count' in dossier) && (_jsx(OtherDossiers, { dossier: dossier }))] }), _jsxs(Panel, { hasNarrowPanelHeight: true, children: [_jsx(H3, { children: t('sidebar.title.financial') }), isProject(PROJECT_INKASSIER) &&
                        'closing_reason' in dossier && (_jsx(DossierFinances, { dossier: dossier })), isProject(PROJECT_INVONED) &&
                        'closing_description' in dossier && (_jsx(InvonedDossierFinances, { dossier: dossier }))] }), _jsxs(Panel, { hasNarrowPanelHeight: true, children: [_jsx(H3, { children: t('sidebar.title.court_calendar_information') }), 'court_calendar_information' in dossier && (_jsx(DossierCourtCalendar, { dossierNumber: dossier.id, courtCalendarInformation: dossier.court_calendar_information }))] }), _jsx(ReportAmountModal, { open: reportModalOpen, dossierNumber: dossier.id, setReportModalOpen: setReportModalOpen }), _jsx(CloseDossierModal, { open: dossierModalOpen, onClose: () => setDossierModalOpen(false), dossierNumber: dossier.id, setDossierModalOpen: setDossierModalOpen }), _jsx(AddressInfoModal, { dossier: dossier, open: addressInfoModalOpen, onClose: success => {
                    setAddressInfoModalOpen(false);
                    if (success === true) {
                        addToast({
                            type: 'success',
                            title: t('address_info.success_notice_title'),
                        });
                    }
                } })] }));
};
export default withInertiaPage(SideBar);
